if (!customElements.get('pair-bundle')) {
  customElements.define('pair-bundle', class PairBundle extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('[data-bundle-variants]').textContent);
      this.discountPercent = Number(this.dataset.discountPercent);
      this.choiceInputs = Array.from(this.querySelectorAll('.pair-bundle__choice input'));
      this.giftVariantIds = Array.from(this.querySelectorAll('[data-gift-variant-id]'), (gift) => gift.dataset.giftVariantId);
      this.selectedPaddle = this.querySelector('[data-selected-paddle]');
      this.button = this.querySelector('[data-bundle-add]');
      this.error = this.querySelector('[data-bundle-error]');
      this.price = this.querySelector('[data-bundle-price]');
      this.compare = this.querySelector('[data-bundle-compare]');
      this.currencyFormatter = new Intl.NumberFormat(this.dataset.locale || undefined, {
        style: 'currency',
        currency: this.dataset.currency,
      });
      this.updateGiftWorth();

      this.onChoiceChange = () => {
        this.error.hidden = true;
        this.update();
      };
      this.choiceInputs.forEach((input) => input.addEventListener('change', this.onChoiceChange));
      this.onAdd = this.addPair.bind(this);
      this.button.addEventListener('click', this.onAdd);

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribeVariant = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          const productInfo = this.getProductInfo();
          if (productInfo && data.sectionId === productInfo.dataset.section) {
            this.error.hidden = true;
            this.update(data.variant?.id);
          }
        });
      }

      this.update();
    }

    disconnectedCallback() {
      this.unsubscribeVariant?.();
      this.choiceInputs?.forEach((input) => input.removeEventListener('change', this.onChoiceChange));
      this.button?.removeEventListener('click', this.onAdd);
    }

    getProductInfo() {
      return document.querySelector(`product-info[data-product-id="${this.dataset.productId}"]`);
    }

    getMainVariant(id) {
      const formInput = this.getProductInfo()?.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
      const variantId = id || formInput?.value;
      return this.variants.find((variant) => String(variant.id) === String(variantId));
    }

    formatPrice(cents) {
      return this.currencyFormatter.format(cents / 100);
    }

    updateGiftWorth() {
      const worth = this.querySelector('[data-gifts-worth]');
      const baseAmount = Number(this.dataset.worthBaseAmount);
      const baseCurrency = this.dataset.worthBaseCurrency;
      const activeCurrency = window.Shopify?.currency?.active;
      const rate = Number(window.Shopify?.currency?.rate);
      if (!worth || !Number.isFinite(baseAmount) || !activeCurrency || (activeCurrency !== baseCurrency && !(rate > 0))) return;

      const convertedAmount = baseAmount * (activeCurrency === baseCurrency ? 1 : rate);
      const formattedAmount = new Intl.NumberFormat(this.dataset.locale || undefined, {
        style: 'currency',
        currency: activeCurrency,
        currencyDisplay: 'code',
      }).format(convertedAmount);
      worth.textContent = this.dataset.worthTemplate.replace('{amount}', formattedAmount);
    }

    update(mainVariantId) {
      this.mainVariant = this.getMainVariant(mainVariantId);
      const main = this.mainVariant;
      const selected = this.choiceInputs.find((input) => input.checked);
      this.secondVariant = selected ? { id: selected.value, price: Number(selected.dataset.price) } : null;
      if (this.selectedPaddle && selected) this.selectedPaddle.textContent = selected.dataset.label;

      if (!main || !main.available) {
        this.button.disabled = true;
        return;
      }

      const second = this.secondVariant;
      this.button.disabled = !second || this.isAdding;
      if (!second) return;

      const discountedSecond = Math.round(second.price * (100 - this.discountPercent) / 100);
      this.price.textContent = this.formatPrice(main.price + discountedSecond);
      this.compare.textContent = this.formatPrice(main.price + second.price);
    }

    async addPair() {
      this.update();
      if (!this.mainVariant?.available || !this.secondVariant || this.isAdding) return;

      this.isAdding = true;
      this.button.disabled = true;
      this.error.hidden = true;

      const drawer = document.querySelector('cart-drawer');
      const notification = document.querySelector('cart-notification');
      const cart = drawer || notification;
      const bundleId = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      const bundleProperties = (role) => ({ _pair_bundle: bundleId, _pair_role: role });
      const body = {
        items: [
          { id: this.mainVariant.id, quantity: 1, properties: bundleProperties('first') },
          { id: this.secondVariant.id, quantity: 1, properties: bundleProperties('second') },
          ...this.giftVariantIds.map((id) => ({ id, quantity: 1, properties: bundleProperties('gift') })),
        ],
      };
      if (cart) {
        body.sections = cart.getSectionsToRender().map((section) => section.id);
        body.sections_url = window.location.pathname;
        cart.setActiveElement(this.button);
      }

      try {
        const response = await fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body),
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || this.dataset.errorLabel);

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'pair-bundle',
            productVariantId: this.mainVariant.id,
            cartData: result,
          });
        }

        if (cart) {
          cart.renderContents(result);
        } else {
          window.location.assign(window.routes.cart_url);
        }
      } catch (error) {
        this.error.textContent = error.message || this.dataset.errorLabel;
        this.error.hidden = false;
      } finally {
        this.isAdding = false;
        this.update();
      }
    }
  });
}
